import React, { ReactElement, useState } from 'react';
import { Button, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import { ResponsePostTimeline } from '../../../../services/api/models/response/responseTimeline';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import { formatDateForPost } from '../../../../common/utils/utils';
import './TimelineDetailModal.scss';
import { BiSend } from 'react-icons/bi';
import {
  useGetCommentPostQuery,
  usePostMessageCommentMutation,
} from '../../../../services/api/apiProvider';
import { Debug } from '../../../../common/utils/debugLogs';

export interface PostItemDetailProps {
  isShow: boolean;
  post: ResponsePostTimeline;
  callBackClose: (child: boolean) => void;
}

const TimelineDetailModal = (props: PostItemDetailProps): ReactElement => {
  const { isShow, post, callBackClose } = props;
  const [messagePost, setMessagePost] = useState<string>('');
  const {
    data: listComment,
    isLoading,
    isSuccess,
  } = useGetCommentPostQuery(post.id);
  const [postMessageComment] = usePostMessageCommentMutation();

  const isPureEnter = (event: any): boolean => {
    const isComposing = event.isComposing || event.keyCode === 229;
    return event.key === 'Enter' && !isComposing;
  };

  const onTextBoxKeyDown = (event: any) => {
    if (isPureEnter(event)) {
      event.preventDefault();
      handleSendMessage();
    }
  };
  const handleTextMessage = (event: any) => {
    setMessagePost(event.target.value);
  };
  const handleSendMessage = () => {
    if (messagePost) {
      const message = {
        id: post.id,
        comment: messagePost.trim(),
      };
      postMessageComment(message)
        .unwrap()
        .catch((error) => {
          Debug.log(`Error when sent message to post reason: ${error}`);
        });
      setMessagePost('');
    }
  };

  const renderListComment = () => {
    if (isLoading) {
      return (
        <div className="block-group__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }
    if (isSuccess && listComment && listComment.length > 0) {
      return (
        <>
          {listComment?.map((item) => (
            <div className="comment-item__user" key={item.id}>
              <div className="comment-item__user-avatar">
                <ImageCustom src={item.sender.picture.uri} />
              </div>
              <div className="comment-item__user-info">
                <div className="comment-item__user-name">
                  {item.sender.loginId}
                </div>
                <div>{item.comment}</div>
                <div className="comment-item__user-feedback">
                  <div className="comment-item__user-time-post">
                    {formatDateForPost(item.commentDateTime)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <Modal
      show={isShow}
      backdrop="static"
      keyboard={false}
      scrollable={true}
      onHide={() => {
        callBackClose(false);
      }}
      size="lg"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div>
          <div className="timeline-post-item__user">
            <div className="timeline__avatar">
              <ImageCustom src={post.user.picture.uri} />
            </div>
            <div className="timeline-post-item__info">
              <div className="timeline-post-item__user-name">
                {post.user.loginId}
              </div>
              <div className="timeline-post-item__time-post">
                {formatDateForPost(post.postDateTime)}
              </div>
            </div>
          </div>
          <div className="timeline-post-item__description">{post.message}</div>
          <div className="timeline-post-item__image">
            <ImageCustom src={post.media.uri} />
          </div>
          <div className="comment-list">{renderListComment()}</div>
          <div className="comment-post-message">
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="コメントしてみましょう"
                value={messagePost}
                onChange={handleTextMessage}
                onKeyDown={(event) => onTextBoxKeyDown(event)}
              />
              <Button
                onClick={handleSendMessage}
                variant="outline-secondary"
                id="button-addon2"
              >
                <BiSend />
              </Button>
            </InputGroup>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default TimelineDetailModal;
